import { useState, useEffect } from 'react'
import { useTranslation } from '../../i18n/LanguageContext'
import API from '../../services/apiService'
import './Announcements.css'

const typeColors = {
  event: '#f59e0b',
  update: '#22c55e',
  maintenance: '#ef4444',
  news: '#3b82f6',
  alert: '#ec4899',
}

const typeIcons = {
  event: '🗓️',
  update: '🔄',
  maintenance: '🔧',
  news: '📢',
  alert: '⚠️',
}

export default function Announcements() {
  const { t } = useTranslation()
  const [announcements, setAnnouncements] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    API.Announcements.list(1, 5, true)
      .then(res => setAnnouncements(Array.isArray(res.data) ? res.data : []))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  if (loading || announcements.length === 0) return null

  return (
    <section className="announcements-bar">
      <div className="announcements-bar__inner">
        <h3 className="announcements-bar__title">📢 {t('announcements.latestNews')}</h3>
        <div className="announcements-bar__list">
          {announcements.map(a => (
            <div key={a.id} className="announcements-bar__item">
              <span className="announcements-bar__type" style={{ color: typeColors[a.type] || '#3b82f6' }}>
                {typeIcons[a.type] || '📢'}
              </span>
              <div className="announcements-bar__content">
                <strong>{a.title}</strong>
                <p>{a.content}</p>
              </div>
              <span className="announcements-bar__date">
                {new Date(a.publishedAt || a.createdAt).toLocaleDateString()}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
